import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost';
  children: React.ReactNode;
  fullWidth?: boolean;
}

const Button: React.FC<ButtonProps> = ({ 
  variant = 'primary', 
  children, 
  className = '', 
  fullWidth = false,
  disabled,
  ...props 
}) => {
  const baseStyles = "relative overflow-hidden font-display uppercase tracking-widest text-sm py-4 px-8 transition-all duration-300 group disabled:cursor-not-allowed disabled:opacity-40";
  
  const variants = {
    primary: "bg-white text-black hover:bg-neutral-200 disabled:hover:bg-white",
    outline: "border border-white/20 text-white hover:border-white hover:bg-white/5 disabled:hover:border-white/20 disabled:hover:bg-transparent",
    ghost: "text-neutral-400 hover:text-white disabled:hover:text-neutral-400"
  };

  const widthClass = fullWidth ? "w-full" : "";

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`}
      disabled={disabled}
      {...props}
    >
      <span className="relative z-10 flex items-center justify-center gap-2">
        {children}
      </span>
    </button>
  );
};

export default Button;